import { Accordion } from "../modules/accordion";

const sections = document.querySelectorAll(".history");

if (sections.length > 0) {
    sections.forEach(section => {
        const accordion = new Accordion({
            el: section,
            collapse: true
        });
    });
}